import React from 'react';
import { Form } from 'react-bootstrap';

const CurrencyInput = ({
                           type,
                           value,
                           name,
                           onChange,
                           readOnly,
                           title,
                           ...props
                       }) => {
    const formatValue = (input) => {
        if (input === '' || input === null || input === undefined) return '';

        // Si ya es un número, lo convertimos a string
        const inputStr = typeof input === 'number' ? input.toString() : input;

        // Elimina todos los caracteres que no sean dígitos o punto
        let cleaned = inputStr.replace(/[^\d.]/g, '');

        // Elimina puntos adicionales (solo permite uno)
        const parts = cleaned.split('.');
        if (parts.length > 2) {
            cleaned = parts[0] + '.' + parts.slice(1).join('');
        }

        // Divide en parte entera y decimal
        const [integer, decimal] = cleaned.split('.');

        // Formatea la parte entera
        let formattedInteger = integer || '0';

        // Limita la parte decimal a 2 dígitos
        let formattedDecimal = '';
        if (decimal !== undefined) {
            formattedDecimal = decimal.slice(0, 2);
        }

        // Combina las partes
        return formattedInteger + (formattedDecimal ? '.' + formattedDecimal : '');
    };

    const handleChange = (e) => {
        const input = e.target.value;
        const formatted = formatValue(input);

        // Si el valor formateado es diferente al input, actualizamos el valor mostrado
        if (formatted !== input) {
            e.target.value = formatted;
        }

        // Llama a la función onChange original con el evento modificado
        onChange(e);
    };

    // Formatea el valor para mostrarlo
    const displayValue = value !== undefined && value !== null ? formatValue(value.toString()) : '';

    return (
        <Form.Control
            type="text" // Forzamos type text para evitar comportamientos nativos de input number
            value={displayValue}
            name={name}
            onChange={handleChange}
            readOnly={readOnly}
            title={title}
            {...props}
        />
    );
};

export default CurrencyInput;